<template>
  <div id="load" class="loadingContent">
    <div v-show="oemShow">
      <div class="row">
        <div
          class="col-xs-12 text-center"
          style="font-size: 50px;margin-top: 300px; color:white;"
        >系统正在初始化中...</div>
      </div>
    </div>

    <div class="row" v-show="pageWrongFlag">
      <div
        class="col-xs-12 text-center"
        style="font-size: 30px;margin-top: 50px;color: red"
      >{{wrongMsg}}</div>
      <div class="col-xs-12 text-center" style="margin-top: 50px;">
        <button
          type="button"
          class="btn btn-warning btn-lg"
          @click="quit()"
          @touchstart="quit()"
        >退出应用</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as deviceOperate from "../assets/js/deviceOperate";
import * as jssFunction from "../assets/js/jssFunction";

export default {
  data() {
    return {
      logoHeight: 0,
      pageWrongFlag: false,
      wrongMsg: "",
      oemShow: true
    };
  },
  beforeMount: function() {},
  mounted: function() {
    this.setTime();
  },
  methods: {
    setTime:function(){
        let that = this;
        let reqData = {};
        this.$http.post(this.GlobalConfig.APP_CONFIG.API_HOST+"getNowTime",JSON.stringify(reqData),this.GlobalConfig.APP_CONFIG.HEADERS)
        .then(function(response) {
            that.syncDevTime(response.data.data);
            that.init();
        }).catch(function(error) {
            deviceOperate.writeAppLog(4,"同步时间异常");
            that.init();
        })
    },
    init: function() {
        try {
            if (global.LOCAL_DATA.devInfo.debug) {
                global.LOCAL_DATA.devInfo.devSn = "TL_MY_01";
            } else {
                let devSn = jssFunction.getQueryString("v");
                if (
                    devSn == "TL_MY_2" ||
                    devSn == "TL_JQ_2" ||
                    devSn == "TL_CY_2" ||
                    devSn == "TL_MY_01"
                ) {
                    global.LOCAL_DATA.devInfo.devSn = devSn;
                } else {
                    global.LOCAL_DATA.devInfo.devSn = deviceOperate.getDev().GetHDSN();
                }
            }
        } catch (e) {
            this.pageWrongFlag = true;
            this.oemShow = false;
            this.wrongMsg = "售票客户端尚未安装或安装失败。";
            return;
        }

        //是否进入主页面标志
        let reqData = {};
        reqData.dev_sn = global.LOCAL_DATA.devInfo.devSn;
        let devSn = global.LOCAL_DATA.devInfo.devSn;
        let that = this;
        let version = 2;
        let url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "terminal/init";
        if (version == 3) {
            url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "terminalApp/init";
        }
        let devHardware = [];
        let versions = deviceOperate.getDev().GetSystemEnv("SYSTEM");
        let fileName = "";
        if(versions=="Android"){
            fileName = "/mnt/sdcard/tl/conf/DeviceCfg.ini";
        }else{
            fileName = "D:\\TerminalApp\\Config\\DeviceCfg.ini";
            
        }
        _.forEach(that.GlobalConfig.DEVICE_CODE,function(n){
            if(n!=910&&n!=140&&n!=310){
                try{
                    let result = deviceOperate.openDevice(n*1, "", "", "");
                    if(result==0){
                       
                        let ret = deviceOperate.getDev().GetDeviceStatus(n*1);
                        let hardwareInfo = {};
                        hardwareInfo.dev_des = deviceOperate.getLastMsg();
                        hardwareInfo.dev_code = deviceOperate.getDev().GetDeviceStatus(n*1)
                        hardwareInfo.part_name = n;
                        hardwareInfo.port = deviceOperate.getDev().GetProfileString(fileName, "DT"+n, "Port", "");
                        hardwareInfo.parm = deviceOperate.getDev().GetProfileString(fileName, "DT"+n, "Parm", "");
                        hardwareInfo.driver_name = deviceOperate.getDev().GetProfileString(fileName, "DT"+n, "DriverName", "");
                        hardwareInfo.driver_ver = deviceOperate.getDev().GetProfileString(fileName, "DT"+n, "DriverVer", "");
                        devHardware.push(hardwareInfo);
                    }
                } catch(e) {

                }
            }
           
        })
        reqData.hardwareInfo = devHardware;
        this.$http
        .post(
            url,
            JSON.stringify(reqData),
            this.GlobalConfig.APP_CONFIG.HEADERS
        )
        .then(function(response) {
            if (response.data.status == "success") {
                let url = response.data.devInfo.version_url;
                if (
                    devSn == "TL_MY_2" ||
                    devSn == "TL_JQ_2" ||
                    devSn == "TL_CY_2" ||
                    devSn == "TL_MY_01"
                ) {
                    url = response.data.devInfo.version_url + "?v=" + devSn;
                }
                window.location.href = url;
            } else {
                that.pageWrongFlag = true;
                that.oemShow = false;

                that.wrongMsg = response.data.msg;
            }
        })
        .catch(function(error) {
            that.oemShow = false;
            that.wrongMsg = "网络异常，请退出检查终端机是否已经联网";
            that.pageWrongFlag = true;
            setTimeout(() => {
                that.init();
            }, 20000);
        });
    },

        syncDevTime: function (strTime) {
                try {
                    let date = strTime.split(" ");
                    let days = date[0].split("-");
                    let times = date[1].split(":");
                    deviceOperate.getDev().SyncSysTime(days[0]*1, days[1]*1, days[2]*1, times[0]*1, times[1]*1, times[2]*1);
                    deviceOperate.writeAppLog(4, "终端同步系统时间成功");
                } catch (e) {
                    deviceOperate.writeAppLog(4, "同步系统时间[" + strTime + "]错误!" + e.toString());

                }
            },
        //退出系统
        quit: function() {
            if (jssFunction.androidClick()) return;
            deviceOperate.getDev().SystemCtrl(10);
        }
    }
};
</script>

<style scoped>
.loadingContent {
    height: 1920px;
    padding-top: 10%;
    font-size: 60px;
    font-weight: bolder;
    overflow: hidden;
    color: white;
    background-image: url("../../static/image/bg/bg03.jpg");
}
.ad {
    display: none;
}

.loading1 {
    width: 450px;
    height: 384px;
    background-position: -450px 0;
    z-index: 1;
}

.loading2 {
    width: 450px;
    height: 0px;
    z-index: 3;
    background-position: left bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue